import React from 'react';
import { Row, Col, Badge } from 'react-bootstrap';
import {
    IconCalendarEvent,
    IconClock,
    IconMapPin,
    IconLink,
    IconUsers,
    IconCopy,
    IconVideo,
    IconInfoCircle,
    IconCalendar,
    IconX,
    IconPoint,
    IconPointFilled
} from '@tabler/icons-react';

export const MeetingDetails = ({ meetingData }) => {
    const brandColor = "#7a3a5e";
    const invitees = meetingData?.invitees && JSON.parse(meetingData.invitees)

    return (
        <div className='d-flex-col px-3 h-100 align-items-stretch'>

            <div className="card-header pb-0 mb-0">
                <h3 style={{ textTransform: "capitalize", fontWeight: 400 }}>
                    Meeting Details
                </h3>
            </div>
            <hr className='my-2 mt-0' />
            <div className="px-0 pb-4 pt-2">
                <Row className="g-4">
                    {/* Left Column: Core Info */}
                    <Col lg={7}>
                        <div className="mb-4">
                            <h3 className="card-header fw-normal mb-3" style={{ color: '#1a202c', textTransform: 'capitalize', fontSize: "24px" }}>
                                {meetingData.meeting_title}
                            </h3>

                            <div className="d-flex align-items-center gap-3 mb-2 text-secondary">
                                <div className="d-flex align-items-center">
                                    <IconCalendarEvent size={18} className="me-2" style={{ color: brandColor }} />
                                    <span className="fw-medium" style={{ fontSize: '14px' }}>{meetingData.meeting_date}</span>
                                </div>
                                <div className="d-flex align-items-center border-start ps-3">
                                    <IconClock size={18} className="me-2" style={{ color: brandColor }} />
                                    <span className="fw-medium" style={{ fontSize: '14px' }}>{meetingData.meeting_from} - {meetingData.meeting_to}</span>
                                </div>
                            </div>

                            <div className="d-flex gap-2 mb-4 mt-3">
                                <Badge
                                    className="d-flex align-items-center border-0 shadow-sm"
                                    style={{ backgroundColor: brandColor, color: 'white', fontSize: '10px', padding: '6px 12px' }}
                                >
                                    <IconVideo size={16} className="me-1" /> {meetingData.meeting_type}
                                </Badge>
                                <Badge
                                    className="border-0 bg-success"
                                    style={{ backgroundColor: '#35f7c1', color: 'white', fontSize: '10px', padding: '6px 8px' }}
                                >
                                    <IconPointFilled size={16} /> {meetingData.meeting_status}
                                </Badge>
                            </div>
                        </div>

                        <div className="mb-4">
                            <div className="d-flex align-items-center mb-2">
                                <IconInfoCircle size={18} className="me-2 text-muted" />
                                <h3 className="mt-0 mb-0" style={{ fontSize: "1rem", fontWeight: 400 }}>Description</h3>
                            </div>
                            <div className="p-3 rounded-3" style={{ backgroundColor: '#fcfaff', color: '#4a5568', fontSize: '14px', borderLeft: `3px solid ${brandColor}` }}>
                                {meetingData.description || "No description."}
                            </div>
                        </div>

                        <div>
                            <h3 className="mt-4 mb-2" style={{ fontSize: "1rem", fontWeight: 400 }}>Access & Link</h3>
                            <div className="p-3 rounded-3 mb-2" style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                <div className="d-flex align-items-center">
                                    <IconMapPin size={20} className="me-3" style={{ color: brandColor }} />
                                    <span className="fw-medium text-dark" style={{ fontSize: '14px' }}>{meetingData.address || "-"}</span>
                                </div>
                            </div>

                            <div className="d-flex align-items-center justify-content-between p-2 ps-3 rounded-3" style={{ background: 'rgba(122, 58, 94, 0.03)', border: '1px dashed #7a3a5e' }}>
                                <div className="d-flex align-items-center text-truncate">
                                    <IconLink size={18} className="me-2" style={{ color: brandColor }} />
                                    <small className="text-truncate fw-medium" style={{ color: brandColor }}>{meetingData.meeting_link || "No meeting link."}</small>
                                </div>
                                <button className="btn btn-sm bg-white shadow-sm border ms-3 rounded-2" onClick={() => navigator.clipboard.writeText(meetingData.meeting_link)}>
                                    <IconCopy size={16} color="#64748b" />
                                </button>
                            </div>
                        </div>
                    </Col>

                    {/* Right Column: People */}
                    <Col lg={5}>
                        <div className="p-4 rounded-4 h-100 border shadow-sm" style={{ backgroundColor: '#fff' }}>
                            <div className="mb-4">
                                <h3 className="mt-0 mb-2" style={{ fontSize: "1rem", fontWeight: 400 }}>Host</h3>
                                {/* <hr className='mt-2 my-2'/> */}
                                <div className="d-flex align-items-center p-2 rounded-3" style={{ backgroundColor: '#fdfcfe', border: '1px solid rgba(122, 58, 94, 0.05)' }}>
                                    <div className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold me-3 shadow-sm"
                                        style={{ width: '40px', height: '40px', background: `linear-gradient(45deg, ${brandColor}, #9d4d7a)` }}>
                                        {meetingData.added_name
                                            ?.split(" ")
                                            .slice(0, 2)
                                            .map(n => n[0])
                                            .join("")
                                        }
                                    </div>
                                    <div>
                                        <div className="fw-bold" style={{ fontSize: '14px', color: '#1a202c' }}>{meetingData.added_name}</div>
                                        <div className="text-uppercase fw-bold" style={{ fontSize: '9px', color: brandColor, letterSpacing: '0.5px' }}>Organizer</div>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex flex-column">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h3 style={{ fontSize: "1rem", fontWeight: 400 }}>Invitees</h3>
                                    <Badge pill bg="light" text="dark" style={{ fontSize: '10px', padding: '4px 8px' }}>{invitees.length}</Badge>
                                </div>

                                <div className="pe-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                    <style jsx>{`
                                        .invitee-list::-webkit-scrollbar { width: 4px; }
                                        .invitee-list::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
                                    `}</style>
                                    <div className="invitee-list">
                                        {invitees.map((person, idx) => (
                                            <div key={idx} className="d-flex align-items-center mb-3">
                                                <div className="rounded-circle border me-3 bg-light d-flex align-items-center justify-content-center fw-bold text-secondary shadow-sm"
                                                    style={{ width: '32px', height: '32px', fontSize: '11px', flexShrink: 0 }}>
                                                    {person.fullName
                                                        ?.split(" ")
                                                        .slice(0, 2)
                                                        .map(n => n[0])
                                                        .join("")
                                                    }
                                                </div>
                                                <div className="text-truncate">
                                                    <div className="fw-semibold text-dark text-truncate" style={{ fontSize: '13px' }}>{person.fullName}</div>
                                                    <div className="text-muted text-truncate" style={{ fontSize: '11px' }}>{person.email}</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="mt-4 pt-3 border-top">
                                    <h3 style={{ fontSize: "1rem", fontWeight: 400 }}>Assigned Team</h3>
                                    <div className="fw-bold d-flex align-items-center" style={{ color: brandColor, fontSize: '13px' }}>
                                        <IconUsers size={16} className="me-2" /> {meetingData.assigned_name}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className="border-0 px-0 pb-4 pt-0">
                <button className="btn btn-lg w-100 fw-bold text-white shadow-lg transition-all"
                    style={{ backgroundColor: brandColor, borderRadius: '10px', fontSize: '15px', border: 'none', padding: '12px' }}>
                    Join Meeting Now
                </button>
            </div>
        </div>
    );
};
